"use strict";

var _defineProperty = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerkleTree = void 0;

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var lisk_utils_1 = require("@liskhq/lisk-utils");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var MerkleTree = /*#__PURE__*/function () {
  function MerkleTree() {
    var initValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, MerkleTree);

    var _a, _b;

    this._width = 0;
    this._hashToValueMap = {};
    this._locationToHashMap = {};

    if (initValues.length <= 1) {
      var rootNode = initValues.length ? this._generateLeaf(initValues[0], 0) : {
        hash: constants_1.EMPTY_HASH,
        value: Buffer.alloc(0)
      };
      this._root = rootNode.hash;
      this._hashToValueMap[this._root.toString('binary')] = rootNode.value;
      this._locationToHashMap["".concat(utils_1.getBinaryString(0, this._getHeight()))] = this._root;
      this._width = initValues.length ? 1 : 0;
      this._preHashedLeaf = (_a = options === null || options === void 0 ? void 0 : options.preHashedLeaf) !== null && _a !== void 0 ? _a : false;
      return;
    }

    this._preHashedLeaf = (_b = options === null || options === void 0 ? void 0 : options.preHashedLeaf) !== null && _b !== void 0 ? _b : false;
    this._root = this._build(initValues);
  }

  _createClass(MerkleTree, [{
    key: "getNode",
    value: function getNode(nodeHash) {
      var value = this._hashToValueMap[nodeHash.toString('binary')];

      if (!value) {
        throw new Error("Hash does not exist in merkle tree: ".concat(nodeHash.toString('hex')));
      }

      var type = utils_1.isLeaf(value) ? "leaf" : "branch";
      var layerIndex = type === "leaf" ? 0 : value.readInt8(constants_1.BRANCH_PREFIX.length);
      var nodeIndex = type === "branch" ? value.readInt32BE(constants_1.BRANCH_PREFIX.length + constants_1.LAYER_INDEX_SIZE) : value.readInt32BE(constants_1.LEAF_PREFIX.length);
      var rightHash = type === "branch" ? value.slice(-1 * constants_1.NODE_HASH_SIZE) : Buffer.alloc(0);
      var leftHash = type === "branch" ? value.slice(-2 * constants_1.NODE_HASH_SIZE, -1 * constants_1.NODE_HASH_SIZE) : Buffer.alloc(0);
      return {
        type: type,
        hash: nodeHash,
        value: value,
        layerIndex: layerIndex,
        nodeIndex: nodeIndex,
        rightHash: rightHash,
        leftHash: leftHash
      };
    }
  }, {
    key: "append",
    value: function append(value) {
      if (this._width === 0) {
        var leaf = this._generateLeaf(value, 0);

        this._root = leaf.hash;
        this._width += 1;
        return this._root;
      }

      var appendPath = [];
      var currentNode = this.getNode(this._root);

      if (this._width === Math.pow(2, this._getHeight() - 1)) {
        appendPath.push(currentNode);
      } else {
        while (true) {
          var currentLayer = currentNode.layerIndex;
          var currentLayerSize = this._width >> currentLayer;

          if (currentLayerSize % 2 === 1 && currentNode.nodeIndex % 2 === 0) {
            appendPath.push(currentNode);
          }

          if (currentNode.type === "leaf") {
            break;
          }

          currentLayerSize = this._width >> currentLayer - 1;

          if (currentLayerSize % 2 === 1) {
            var leftNode = this.getNode(currentNode.leftHash);
            appendPath.push(leftNode);
          }

          currentNode = this.getNode(currentNode.rightHash);
        }
      }

      var appendData = this._generateLeaf(value, this._width);

      var appendNode = this.getNode(appendData.hash);
      appendPath.push(appendNode);

      while (appendPath.length > 1) {
        var rightNodeInfo = appendPath.pop();
        var leftNodeInfo = appendPath.pop();

        var newBranchNode = this._generateBranch(leftNodeInfo.hash, rightNodeInfo.hash, leftNodeInfo.layerIndex + 1, leftNodeInfo.nodeIndex + 1);

        appendPath.push(this.getNode(newBranchNode.hash));
      }

      this._root = appendPath[0].hash;
      return this.root;
    }
  }, {
    key: "generateProof",
    value: function generateProof(queryData) {
      if (this._width === 0) {
        return {
          path: [],
          indexes: [],
          dataLength: 0
        };
      }

      var path = [];
      var addedPath = new lisk_utils_1.dataStructures.BufferSet();
      var indexes = [];
      var queryNode;

      for (var i = 0; i < queryData.length; i += 1) {
        try {
          queryNode = this.getNode(queryData[i]);
        } catch (err) {
          path.push({
            hash: queryData[i],
            layerIndex: undefined,
            nodeIndex: undefined
          });
          indexes.push({
            layerIndex: undefined,
            nodeIndex: undefined
          });
          continue;
        }

        if (this._width === 1 && this._root.equals(queryNode.hash)) {
          if (!addedPath.has(queryNode.hash)) {
            addedPath.add(queryNode.hash);
            path.push({
              hash: queryNode.hash,
              layerIndex: 0,
              nodeIndex: 0
            });
            indexes.push({
              layerIndex: 0,
              nodeIndex: 0
            });
          }

          continue;
        }

        indexes.push({
          layerIndex: queryNode.layerIndex,
          nodeIndex: queryNode.nodeIndex
        });
        var currentNode = queryNode;

        while (!currentNode.hash.equals(this._root)) {
          var _utils_1$getPairLocat = utils_1.getPairLocation({
            layerIndex: currentNode.layerIndex,
            nodeIndex: currentNode.nodeIndex,
            dataLength: this._width
          }),
              pairLayerIndex = _utils_1$getPairLocat.layerIndex,
              pairNodeIndex = _utils_1$getPairLocat.nodeIndex,
              pairSide = _utils_1$getPairLocat.side;

          var pairNodeHash = this._locationToHashMap["".concat(utils_1.getBinaryString(pairNodeIndex, this._getHeight() - pairLayerIndex))];

          if (!addedPath.has(pairNodeHash)) {
            addedPath.add(pairNodeHash);
            path.push({
              hash: pairNodeHash,
              layerIndex: pairLayerIndex,
              nodeIndex: pairNodeIndex
            });
          }

          var leftHashBuffer = pairSide === 0 ? pairNodeHash : currentNode.hash;
          var rightHashBuffer = pairSide === 1 ? pairNodeHash : currentNode.hash;
          var parentNodeHash = utils_1.generateHash(constants_1.BRANCH_PREFIX, leftHashBuffer, rightHashBuffer);
          currentNode = this.getNode(parentNodeHash);
        }
      }

      return {
        path: path,
        indexes: indexes,
        dataLength: this._width
      };
    }
  }, {
    key: "clear",
    value: function clear() {
      this._width = 0;
      this._root = constants_1.EMPTY_HASH;
      this._hashToValueMap = _defineProperty({}, this._root.toString('2'), Buffer.alloc(0));
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this._width === 0) {
        return this.root.toString('hex');
      }

      return this._printNode(this.root);
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this = this;

      return this._width === 0 ? [] : Object.keys(this._hashToValueMap).map(function (key) {
        return _this.getNode(Buffer.from(key, 'binary'));
      });
    }
  }, {
    key: "_getHeight",
    value: function _getHeight() {
      return Math.ceil(Math.log2(this._width)) + 1;
    }
  }, {
    key: "_generateLeaf",
    value: function _generateLeaf(value, nodeIndex) {
      var nodeIndexBuffer = Buffer.alloc(constants_1.NODE_INDEX_SIZE);
      nodeIndexBuffer.writeInt32BE(nodeIndex, 0);
      var leafValueWithoutNodeIndex = Buffer.concat([constants_1.LEAF_PREFIX, value], constants_1.LEAF_PREFIX.length + value.length);
      var leafHash = this._preHashedLeaf ? value : lisk_cryptography_1.hash(leafValueWithoutNodeIndex);
      var leafValueWithNodeIndex = Buffer.concat([constants_1.LEAF_PREFIX, nodeIndexBuffer, value], constants_1.LEAF_PREFIX.length + nodeIndexBuffer.length + value.length);
      this._hashToValueMap[leafHash.toString('binary')] = leafValueWithNodeIndex;
      this._locationToHashMap["".concat(utils_1.getBinaryString(nodeIndex, this._getHeight()))] = leafHash;
      return {
        value: leafValueWithNodeIndex,
        hash: leafHash
      };
    }
  }, {
    key: "_generateBranch",
    value: function _generateBranch(leftHashBuffer, rightHashBuffer, layerIndex, nodeIndex) {
      var layerIndexBuffer = Buffer.alloc(constants_1.LAYER_INDEX_SIZE);
      var nodeIndexBuffer = Buffer.alloc(constants_1.NODE_INDEX_SIZE);
      layerIndexBuffer.writeInt8(layerIndex, 0);
      nodeIndexBuffer.writeInt32BE(nodeIndex, 0);
      var branchValue = Buffer.concat([constants_1.BRANCH_PREFIX, layerIndexBuffer, nodeIndexBuffer, leftHashBuffer, rightHashBuffer], constants_1.BRANCH_PREFIX.length + layerIndexBuffer.length + nodeIndexBuffer.length + leftHashBuffer.length + rightHashBuffer.length);
      var branchHash = utils_1.generateHash(constants_1.BRANCH_PREFIX, leftHashBuffer, rightHashBuffer);
      this._hashToValueMap[branchHash.toString('binary')] = branchValue;
      this._locationToHashMap["".concat(utils_1.getBinaryString(nodeIndex, this._getHeight() - layerIndex))] = branchHash;
      return {
        hash: branchHash,
        value: branchValue
      };
    }
  }, {
    key: "_build",
    value: function _build(initValues) {
      var leafHashes = [];
      this._width = initValues.length;

      for (var i = 0; i < initValues.length; i += 1) {
        var leaf = this._generateLeaf(initValues[i], i);

        leafHashes.push(leaf.hash);
      }

      var currentLayerIndex = 0;
      var currentLayerHashes = leafHashes;
      var orphanNodeHashInPreviousLayer;

      while (currentLayerHashes.length > 1 || orphanNodeHashInPreviousLayer !== undefined) {
        var pairsOfHashes = [];

        for (var _i = 0; _i < currentLayerHashes.length - 1; _i += 2) {
          pairsOfHashes.push([currentLayerHashes[_i], currentLayerHashes[_i + 1]]);
        }

        if (currentLayerHashes.length % 2 === 1) {
          if (orphanNodeHashInPreviousLayer === undefined) {
            orphanNodeHashInPreviousLayer = currentLayerHashes[currentLayerHashes.length - 1];
          } else {
            pairsOfHashes.push([currentLayerHashes[currentLayerHashes.length - 1], orphanNodeHashInPreviousLayer]);
            orphanNodeHashInPreviousLayer = undefined;
          }
        }

        var parentLayerHashes = [];

        for (var _i2 = 0; _i2 < pairsOfHashes.length; _i2 += 1) {
          var leftHash = pairsOfHashes[_i2][0];
          var rightHash = pairsOfHashes[_i2][1];

          var node = this._generateBranch(leftHash, rightHash, currentLayerIndex + 1, _i2);

          parentLayerHashes.push(node.hash);
        }

        currentLayerHashes = parentLayerHashes;
        currentLayerIndex += 1;
      }

      return currentLayerHashes[0];
    }
  }, {
    key: "_printNode",
    value: function _printNode(hashValue) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var nodeValue = this._hashToValueMap[hashValue.toString('binary')];

      if (nodeValue && utils_1.isLeaf(nodeValue)) {
        return hashValue.toString('hex');
      }

      var node = this.getNode(hashValue);
      return [hashValue.toString('hex'), "\u251C".concat(' ─ '.repeat(level), " ").concat(this._printNode(node.leftHash, level + 1)), "\u251C".concat(' ─ '.repeat(level), " ").concat(this._printNode(node.rightHash, level + 1))].join('\n');
    }
  }, {
    key: "root",
    get: function get() {
      return this._root;
    }
  }]);

  return MerkleTree;
}();

exports.MerkleTree = MerkleTree;